import {
  FETCH_ALL_MEMBERS_REQUEST,
  FETCH_ALL_MEMBERS_SUCCESS,
  FETCH_ALL_MEMBERS_FAILURE,
  FETCH_ACTIVE_MEMBERS_REQUEST,
  FETCH_ACTIVE_MEMBERS_SUCCESS,
  FETCH_ACTIVE_MEMBERS_FAILURE,
} from "../actions/membersActionTypes.js";

const initialState = {
  allMembers: [],
  activeMembers: [],
  isLoading: false,
  error: null,
};

const membersReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ALL_MEMBERS_REQUEST:
    case FETCH_ACTIVE_MEMBERS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };

    case FETCH_ALL_MEMBERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        allMembers: action.payload,
        error: null,
      };

    case FETCH_ACTIVE_MEMBERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activeMembers: action.payload,
        error: null,
      };

    case FETCH_ALL_MEMBERS_FAILURE:
    case FETCH_ACTIVE_MEMBERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default membersReducer;
